<template>
  <section class="quick-answers-container">
    <p>Al activar esta opción, los usuarios recibirán un sonido de alerta cuando llegue un nuevo mensaje en los tickets activos.</p>
  </section>
  <div class="card-container">
    Activar sonido
    <a-switch :checked="selectedOption" @change="changeOption"/>
    <a-divider type="vertical"></a-divider>
    <a-button class="button_sound" type="primary" ghost @click="playSound">
      <IconAudio :width="16" :height="14" primary />
      Escuchar
    </a-button>
  </div>
  <div style="margin: 15px 0">
    <a-alert
      message="Esta configuración permanecerá para todos los usuarios con acceso a workspace."
      type="warning"
      show-icon />
  </div>
  <div class="footer">
    <a-button type="primary" @click="handleSave" :loading="loading" :disabled="!canSave">
      Guardar cambios
    </a-button>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from "vue";
import { apiService } from "@/app/platformSettings/services/ApiService";
import { message } from "ant-design-vue";
import { SoundOutlined } from "@ant-design/icons-vue";
import IconAudio from "@/app/common/components/atoms/IconAudio.vue";
import newInboundMessageUrl from "@/app/shared/assets/audio/incoming-message.mp3";

const newInboundMessage = new Audio(newInboundMessageUrl);

const props = defineProps<{
  enable_sound_message?: boolean;
}>();

const selectedOption = ref<Boolean>(false);

const loading = ref<boolean>(false);

const canSave = ref<boolean>(false);

const emit = defineEmits<{
  "update:enable_sound_message": [enable_sound_message: boolean];
}>();

const handleClose = () => {};

const handleSave = async () => {
  loading.value = true;
  try {
    await apiService.updateSoundIncoming(selectedOption.value);
    emit("update:enable_sound_message", selectedOption.value);
    canSave.value = false;
    setTimeout(() => {
      loading.value = false;
    }, 1000);
    message.success("El cambio se realizo correctamente.");
  } catch (error: any) {
    console.error(error.getErrorMessage() || "Ocurrio un error");
    message.error(error.getErrorMessage() || "Ocurrio un error");
  }
};

const changeOption = (option: Boolean) => {
  selectedOption.value = option;
  canSave.value = selectedOption.value !== props.enable_sound_message ? true : false;
};

const playSound = () => {
  newInboundMessage.play();
}

onMounted(async () => {
  selectedOption.value = props.enable_sound_message;
});
</script>
<style scoped lang="sass">
.card-container
  display: flex
  justify-content: left
  align-items: center
  gap: 10px
  // padding: 20px


.custom-card
  width: 800px
  display: flex
  flex-direction: column
  justify-content: space-between
  padding: 6px


.quick-answers-container
  margin-bottom: 20px

.footer
  justify-content: end
  display: flex
  gap: 10px

.selected-card
  border-color: blue

.button_sound
  display: flex
  align-items: center
  gap: 5px
</style>
